// extracted by mini-css-extract-plugin
export default {"tabletImg":"nP","desktopImg":"oP","mobileImg":"pP","backgroundImage":"qP","content":"rP","rtbLeft":"sP","rtbRight":"tP","imageContainer":"uP","rtbBox":"vP","line":"wP"};
    if(module.hot) {
      // 1737143662629
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  